import { Checkbox, Grid, TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { icons } from "../constants";

const TableHeadComponent = ({
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  detailsPageReports,
  TableHeadData,
}) => {
  // const TableHeadComponent = (props) => {
  //   const {
  //     onSelectAllClick,
  //     order,
  //     orderBy,
  //     numSelected,
  //     rowCount,
  //     onRequestSort,
  //     detailsPageReports,
  //     TableHeadData,
  //   } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableRow>
        {detailsPageReports ? undefined : (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                "aria-label": "select all desserts",
              }}
            />
          </TableCell>
        )}
        {TableHeadData.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            padding={"none"}
            style={{
              border: "1px solid #BABABA",
              minWidth: headCell.width,
              maxWidth: headCell.width,
              width: headCell.width,
              padding: headCell.cellPadding ?? "0px 10px",
              height: 36,
            }}
            // style={{ border: "1px solid #F2F2F2", minWidth: headCell.width }}
            // align={headCell.numeric ? "right" : "left"}
            // padding={headCell.disablePadding ? "none" : "normal"}
            // sortDirection={orderBy === headCell.id ? order : false}
          >
            {/*
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={createSortHandler(headCell.id)}
            style={{ color: "#020303", fontWeight: 700, fontSize: 14 }}
          >
        */}
            <Grid container>
              <span style={tableHeadTextStyles}>{headCell.label}</span>
              {headCell.id === "photo" ||
              headCell.id === "audio" ||
              headCell.sortable === false ? undefined : (
                <img
                  src={
                    orderBy === headCell.id
                      ? order === "asc"
                        ? icons.SortSelectedIcon
                        : icons.SortSelectedDescIcon
                      : icons.TableHeadIcon
                  }
                  alt=""
                  onClick={createSortHandler(headCell.id)}
                  style={filterIconStyles}
                />
              )}
              {/*
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  */}
            </Grid>
            {/*
              </TableSortLabel>
        */}
          </TableCell>
        ))}
    </TableRow>
  );
};

export default TableHeadComponent;

const tableHeadTextStyles = {
  color: "#020303",
  fontWeight: 700,
  fontSize: 14,
  fontFamily: "Avenir Book, sans-serif",
};

const filterIconStyles = {
  width: 24,
  height: 24,
  marginLeft: "auto",
  cursor: "pointer",
};
